import React from 'react'

import { WrapperLayout as ModalWrapper } from 'components/Utils/Modal/WrapperLayout'
import { Input, Text, Button } from 'components/base'
import { ErrorIcon } from 'components/Utils/Icons'

function formatDomain(domain: string) {
  return domain
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]/g, '-')
    .slice(0, 35)
}

type ChangeDomainProps = {
  organizationDomain: string
  updateOrganizationDomain: (domain: string) => void
  useDomainAvailability: (
    organizationDomain: string
  ) => {
    error: string | null
    checkDomainAvailability: (domain: string) => void
  }
  isOpen: boolean
  onClose: () => void
}

function ChangeDomain({
  organizationDomain,
  useDomainAvailability,
  updateOrganizationDomain,
  isOpen,
  onClose,
}: ChangeDomainProps) {
  const [domain, setDomain] = React.useState(organizationDomain)
  const { error, checkDomainAvailability } = useDomainAvailability(
    organizationDomain
  )

  function onChangeDomain(event: React.ChangeEvent<HTMLInputElement>) {
    setDomain(formatDomain(event.target.value))
    checkDomainAvailability(domain)
  }

  const onSave = () => {
    updateOrganizationDomain(domain)
  }

  return (
    <ModalWrapper isOpen={isOpen} onRequestClose={onClose} size={500}>
      <div className="padding-largest">
        <Text.Title className="margin-bottom-medium">
          Are you sure you want to rename your team URL?
        </Text.Title>
        <div
          style={{ borderColor: '#FFBDC5' }}
          className="radius-normal border-small padding-medium flexbox flexbox-align-center margin-bottom-medium"
        >
          <ErrorIcon size={16} className="margin-right-medium red" />
          <div className="red font-weight-medium">
            Please read these side effects before renaming
          </div>
        </div>
        <div className="margin-bottom-large line-height-larger shade-10 bold">
          <div>- Your public and private shared links will no longer work.</div>
          <div>- Your invite links will no longer work.</div>
          <div>- All your team will be logged out, you included.</div>
          <div>
            - URL update is effective immediately after validating below.
          </div>
        </div>
        <Text.Name className="margin-bottom-smaller shade-05">
          Team domain
        </Text.Name>
        <Input
          value={domain}
          rightText={'.slite.com'}
          onChange={onChangeDomain}
        />
        <div
          className="margin-bottom-normal font-size-normal font-weight-medium"
          style={{ color: 'red', height: 22 }}
        >
          {error}
        </div>
        <div className="margin-bottom-large font-size-normal shade-10">
          We will send your members an email with the new URL. In the meantime
          we advise you to inform them about the update.
        </div>
        <div className="flexbox flexbox-align-center flexbox-space-between">
          <Button.Secondary onClick={onClose}>Cancel</Button.Secondary>
          <Button.Danger
            onClick={onSave}
            disabled={error || domain === organizationDomain}
          >
            I understand, rename anyway
          </Button.Danger>
        </div>
      </div>
    </ModalWrapper>
  )
}

export default ChangeDomain
